var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("History")]),_c('ul',{staticClass:"history_list"},_vm._l((_vm.historyData),function(line,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(line)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }